<template>
	<v-container>
		<v-card v-if="bookingComplete">
			<v-list-item three-line class="text-center">
				<v-list-item-content>
					<v-icon size="64" color="green">
						sentiment_satisfied_alt
					</v-icon>
					<v-list-item-title
						v-if="!bookingMediated"
						class="mb-6 display-1 green--text"
						>Booking confirmed!</v-list-item-title
					>
					<v-list-item-title
						v-if="bookingMediated"
						class="mb-6 display-1 green--text"
						>Booking awaiting approval</v-list-item-title
					>
					<div class="details">
						<v-list-item-subtitle class="title font-weight-black">
							<v-icon size="35">schedule</v-icon>
							{{ formattedDate }}
							{{ formattedSlot }}
						</v-list-item-subtitle>

						<v-list-item-subtitle class="title font-weight-black">
							<v-icon size="35">location_on</v-icon>
							{{ asset.name }} at
							{{ asset.location_name }}
						</v-list-item-subtitle>
					</div>
				</v-list-item-content>
			</v-list-item>
			<v-card-text>
				<div v-html="category.thank_you_message"></div>
				<v-list>
					<v-list-item two-line>
						<v-list-item-content>
							<v-list-item-title>Name</v-list-item-title>
							<v-list-item-subtitle class="pl-3">
								{{ form.firstName }} {{ form.lastName }}
							</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
					<v-list-item two-line>
						<v-list-item-content>
							<v-list-item-title>Email</v-list-item-title>
							<v-list-item-subtitle class="pl-3">
								{{ form.email }}
							</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
					<v-list-item two-line v-if="form.cell">
						<v-list-item-content>
							<v-list-item-title>Cell #</v-list-item-title>
							<v-list-item-subtitle class="pl-3">
								{{ form.cell }}
							</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
				</v-list>
				<v-list v-if="group.custom_fields.fields">
					<v-list-item
						two-line
						v-for="(field, index) in group.custom_fields.fields"
						:key="index"
					>
						<v-list-item-content>
							<v-list-item-title class="custom-field-question">{{
								field.title
							}}</v-list-item-title>
							<v-list-item-subtitle class="pl-3">
								{{
									field.type !== 'checkbox'
										? form[field.name]
										: form[field.name]
										? 'Yes'
										: 'No'
								}}
							</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
				</v-list>
				<div v-html="group.instructions"></div>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
					class="white--text"
					@click="finished()"
					x-large
					color="teal"
					>Finished</v-btn
				>
				<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>
		<!-- START ILS Integration -->
		<v-card
			class="mx-auto"
			v-if="
				asset &&
					!bookingComplete &&
					group.ils_integration &&
					group.ils_integration_options.require_patron_login ===
						'true' &&
					!ilsSignInComplete
			"
			max-width="700"
		>
			<v-list-item two-line>
				<v-list-item-content>
					<v-list-item-title class="headline">{{
						$t('assets.pleaseSignIn')
					}}</v-list-item-title>
					<v-list-item-subtitle>
						{{ formattedDate }}
						{{ formattedSlot }} {{ asset.name }} at
						{{ asset.location_name }}
					</v-list-item-subtitle>
				</v-list-item-content>
				<v-icon large right>
					schedule
				</v-icon>
			</v-list-item>
			<v-divider></v-divider>
			<v-card-text>
				<v-form ref="signinform" v-model="valid">
					<v-row>
						<v-col cols="12">
							<v-text-field
								:label="$tc('global.librarycardnumber', 1)"
								placeholder=""
								outlined
								v-model="signinform.patronBarcode"
								:rules="[rules.required]"
								required
							></v-text-field>
						</v-col>
						<v-col
							cols="12"
							v-if="!clientSettings.client_pinless_auth"
						>
							<v-text-field
								:label="$tc('global.librarycardpin', 1)"
								:type="'password'"
								placeholder="****"
								outlined
								v-model="signinform.patronPin"
								:rules="[rules.required]"
								required
							></v-text-field>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-divider></v-divider>

			<v-card-actions>
				<v-btn outlined color="teal" @click="$router.go(-1)">{{
					$t('global.back')
				}}</v-btn>
				<v-spacer></v-spacer>
				<v-progress-circular
					class="mr-2"
					v-if="submitting"
					:indeterminate="true"
					:rotate="0"
					:size="32"
					:value="0"
					:width="4"
					color="teal"
				></v-progress-circular>
				<v-btn
					@keyup.enter="
						signInToILS(
							signinform.patronBarcode,
							signinform.patronPin
						)
					"
					:disabled="!valid || submitting"
					class="white--text"
					color="teal"
					@click="
						signInToILS(
							signinform.patronBarcode,
							signinform.patronPin
						)
					"
					>{{ $t('global.signin') }}</v-btn
				>
			</v-card-actions>
		</v-card>
		<!-- END ILS Integration -->
		<v-card
			class="mx-auto"
			v-if="
				asset &&
					!bookingComplete &&
					(!group.ils_integration ||
						(!bookingComplete &&
							group.ils_integration &&
							group.ils_integration_options
								.require_patron_login === 'true' &&
							ilsSignInComplete) ||
						(group.ils_integration &&
							group.ils_integration_options
								.require_patron_login === 'false'))
			"
			max-width="700"
		>
			<v-list-item two-line>
				<v-list-item-content>
					<v-list-item-title class="headline"
						>Confirm your booking</v-list-item-title
					>
					<v-list-item-subtitle>
						{{ formattedDate }}
						{{ formattedSlot }} {{ asset.name }}
						<span v-if="!asset.is_online">
							at
							{{ asset.location_name }}
						</span>
					</v-list-item-subtitle>
				</v-list-item-content>
				<v-icon large right>
					schedule
				</v-icon>
			</v-list-item>
			<v-list-item v-if="asset.is_mediated">
				<v-list-item-content>
					<v-list-item-title>
						<div class="mediation-information-box">
							<p class="icon">
								<i
									class="fa fa-exclamation-circle"
									aria-hidden="true"
								></i>
							</p>
							<div class="box-content">
								<p class="box-title">Please note</p>
								<p class="box-message">
									This booking will require approval.
								</p>
							</div>
						</div>
					</v-list-item-title>
				</v-list-item-content>
			</v-list-item>
			<!-- rendering event type dynamically / COM-11074 -->
			<v-list-item v-if="isVirtual">
				<v-list-item-content>
					<v-list-item-title>
						This is a virtual appointment. Instructions for how to
						join the call will be sent via email.
					</v-list-item-title>
				</v-list-item-content>
			</v-list-item>
			<v-list-item v-else>
				<v-list-item-content>
					<v-list-item-title>
						This is an in-person appointment, Further instructions
						will be sent via email.
					</v-list-item-title>
				</v-list-item-content>
			</v-list-item>

			<v-divider></v-divider>
			<v-card-text>
				<v-form
					ref="signinform"
					v-if="
						group.ils_integration &&
							group.ils_integration_options
								.require_patron_login === 'false'
					"
				>
					<v-row>
						<v-list-item-subtitle class="ml-3 text-wrap">
							{{ $t('assets.lookupDetailsDescription') }}
						</v-list-item-subtitle>
						<v-col cols="12" sm="6">
							<v-text-field
								:label="
									`${$tc('global.librarycardnumber', 1)} ${$t(
										'global.optional'
									)}`
								"
								placeholder=""
								outlined
								v-model="signinform.patronBarcode"
							></v-text-field>
						</v-col>
						<v-col cols="12" sm="6">
							<v-text-field
								:label="
									`${$tc('global.librarycardpin', 1)} ${$t(
										'global.optional'
									)}`
								"
								:type="'password'"
								placeholder="****"
								outlined
								v-model="signinform.patronPin"
							></v-text-field>
						</v-col>
					</v-row>
					<v-row>
						<v-spacer></v-spacer>
						<v-progress-circular
							class="mr-2"
							v-if="submitting"
							:indeterminate="true"
							:rotate="0"
							:size="32"
							:value="0"
							:width="4"
							color="teal"
						></v-progress-circular>
						<v-btn
							@keyup.enter="
								signInToILS(
									signinform.patronBarcode,
									signinform.patronPin
								)
							"
							class="mr-3 white--text"
							:disabled="
								this.form.patronBarcode === '' ||
									this.form.patronPin === ''
							"
							color="teal"
							@click="
								signInToILS(
									signinform.patronBarcode,
									signinform.patronPin
								)
							"
							>{{ $t('global.lookupDetails') }}</v-btn
						>
					</v-row>
					<v-divider class="mt-2"></v-divider>
				</v-form>
				<v-form ref="form" v-model="valid">
					<v-row>
						<v-col cols="12" sm="6">
							<v-text-field
								label="First name *"
								placeholder=""
								outlined
								v-model="form.firstName"
								:rules="[rules.required, rules.name]"
								required
							></v-text-field>
						</v-col>
						<v-col cols="12" sm="6">
							<v-text-field
								label="Last name *"
								placeholder=""
								outlined
								v-model="form.lastName"
								:rules="[rules.required, rules.name]"
								required
							></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-text-field
								:label="
									group.email_required
										? 'Email address *'
										: 'Email address'
								"
								placeholder="email@address.com"
								outlined
								type="email"
								v-model="form.email"
								:rules="
									group.email_required
										? [rules.required, rules.email]
										: [rules.email]
								"
								required
							></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-text-field
								:label="
									group.cell_required ? 'Cell # *' : 'Cell #'
								"
								v-model="form.cell"
								:rules="
									group.cell_required
										? [rules.required, rules.cell]
										: [rules.cell]
								"
								required
								placeholder="111-111-1111"
								outlined
							></v-text-field>
						</v-col>
					</v-row>
					<v-row v-if="group.custom_fields.fields">
						<v-col
							cols="12"
							v-for="(field, index) in group.custom_fields.fields"
							:key="index"
						>
							<v-text-field
								v-if="field.type === 'text'"
								:label="getTitle(field)"
								:messages="field.helpText || ''"
								:rules="getRules(field)"
								v-model="form[field.name]"
								outlined
							></v-text-field>
							<v-textarea
								v-if="field.type === 'textarea'"
								:label="getTitle(field)"
								:messages="field.helpText || ''"
								:rules="getRules(field)"
								v-model="form[field.name]"
								outlined
							></v-textarea>
							<v-checkbox
								v-if="field.type === 'checkbox'"
								:label="getTitle(field)"
								:messages="getCheckboxMessages(field)"
								:rules="getRules(field)"
								v-model="form[field.name]"
								outlined
							>
								<template v-slot:message>
									<a
										v-if="hasFieldLink(field)"
										:href="field.link"
									>
										{{ getLinkText(field) }}
									</a>
									<p v-else-if="hasFieldHelpText(field)">
										{{ field.helpText }}
									</p>
								</template>
							</v-checkbox>

							<v-select
								:items="field.options.split('\n')"
								v-if="field.type === 'select'"
								:label="getTitle(field)"
								:messages="field.helpText || ''"
								:rules="getRules(field)"
								v-model="form[field.name]"
								outlined
							></v-select>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-divider></v-divider>

			<v-card-actions>
				<v-btn outlined color="teal" @click="$router.go(-1)">{{
					$t('global.back')
				}}</v-btn>
				<v-spacer></v-spacer>
				<v-btn
					:disabled="!valid || submitting"
					class="white--text"
					color="teal"
					@click="submitBooking()"
					>{{ $t('global.confirm') }}</v-btn
				>
			</v-card-actions>
		</v-card>
		<v-snackbar v-model="showError" :timeout="timeout">
			{{ errorMessage }}
			<v-btn color="blue" text @click="showError = false">
				Close
			</v-btn>
		</v-snackbar>
	</v-container>
</template>

<script>
import moment from 'moment';
import { ilsSignin } from '../components/mixins/ilsSignin';
import { scheduleHeightPost } from '../utils/embed-bridge';

export default {
	mixins: [ilsSignin],
	data() {
		return {
			showError: false,
			timeout: 5000,
			errorMessage: '',
			submitting: false,
			valid: false,
			validateName: false,
			bookingComplete: false,
			bookingMediated: false,
			form: {
				firstName: '',
				lastName: '',
				cell: '',
				email: ''
			},
			signinform: {
				patronBarcode: '',
				patronPin: ''
			},
			rules: {
				required: value =>
					!!value || this.$i18n.t('validation.required'),
				pinRequired: value =>
					this.clientSettings.client_pinless_auth
						? true
						: !!value || this.$i18n.t('validation.required'),
				counter: value =>
					value.length <= 20 ||
					this.$i18n.t('validation.maximums.20chars'),
				cell: value => {
					let rephone = new RegExp(
						this.clientSettings.schedule_phone_number_regex,
						'i'
					);
					return (
						rephone.test(value) ||
						this.$i18n.t('validation.invalidCell')
					);
				},
				email: value => {
					const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
					return (
						(this.group.email_required && pattern.test(value)) ||
						!this.group.email_required ||
						this.$i18n.t('validation.invalidEmail')
					);
				},
				name: value => {
					const characterLimitPattern = /^[a-zA-Z\s]{1,30}$/;
					let result = false;
					result = !(
						this.validateName && characterLimitPattern.test(value)
					)
						? this.$i18n.t('validation.invalidName')
						: false;
					result =
						value.length <= 30 ||
						this.$i18n.t('validation.maximums.30chars');

					return result;
				}
			}
		};
	},
	created() {
		this.keyword = window.config.keyword;
	},
	mounted() {
		this.$store.dispatch('fetchAsset', this.id).then(() =>
			Promise.all([
				this.$store.dispatch('fetchClientSettings'),
				this.$store.dispatch('fetchAssetGroup', {
					id: this.asset.group_id,
					date: this.selectedDate
				}),
				this.$store.dispatch(
					'fetchAssetCategory',
					this.asset.category_id
				)
			]).then(() => {
				this.queueHeightSync();
			})
		);

		if (this.clientSettings.appointment_force_name_format) {
			this.validateName = this.clientSettings.appointment_force_name_format;
		}
		// this.bookingComplete = true;
	},
	methods: {
		queueHeightSync() {
			this.$nextTick(() => {
				scheduleHeightPost();
			});
		},
		getRules(field) {
			const rules = [];
			if (field.required) {
				rules.push(this.rules.required);
			}
			if (field.validate === 'email') {
				rules.push(this.rules.email);
			} else if (field.validate === 'phone') {
				rules.push(this.rules.cell);
			} else if (field.validate === 'custom') {
				rules.push(value => {
					var flags = field.regex.replace(/.*\/([gimy]*)$/, '$1');
					var pattern = field.regex.replace(
						new RegExp('^/(.*?)/' + flags + '$'),
						'$1'
					);
					var regex = new RegExp(pattern, flags);
					return (
						(!field.required && !value) ||
						regex.test(value) ||
						this.$i18n.t('assets.booking.invalid')
					);
				});
			}
			return rules;
		},
		getTitle(field) {
			return !field.required ? field.title : `${field.title} *`;
		},
		hasFieldLink(field) {
			return (
				field &&
				typeof field.link === 'string' &&
				field.link.trim().length > 0
			);
		},
		hasFieldHelpText(field) {
			return (
				field &&
				typeof field.helpText === 'string' &&
				field.helpText.trim().length > 0
			);
		},
		getLinkText(field) {
			if (this.hasFieldHelpText(field)) {
				return field.helpText;
			}
			return this.hasFieldLink(field) ? field.link : '';
		},
		getCheckboxMessages(field) {
			if (this.hasFieldHelpText(field)) {
				return field.helpText;
			}
			if (this.hasFieldLink(field)) {
				return this.getLinkText(field);
			}
			return '';
		},
		submitBooking() {
			this.submitting = true;
			const assetType = this.$route.query.assetType || 'INPERSON';
			const data = {
				client_id: this.clientDetails.id,
				location_id: this.asset.location_id,
				category_id: this.asset.category_id,
				group_id: this.asset.group_id,
				asset_id: this.asset.id,
				start_time: this.bookingDateTime,
				slot: this.slot,
				booking_length: this.blockSize,
				first_name: this.form.firstName,
				last_name: this.form.lastName,
				email: this.form.email,
				cell: this.form.cell,
				custom_questions: '',
				patron_data: JSON.stringify(this.ilsPatronDetails),
				booking_source: 'WEB_V1',
				availability_type: assetType
			};
			if (this.group.custom_fields.fields) {
				const custom_questions = {};
				this.group.custom_fields.fields.forEach(field => {
					let defaultAnswer = field.type !== 'checkbox' ? '' : false;
					let answer = this.form[field.name]
						? this.form[field.name]
						: defaultAnswer;
					custom_questions[field.name] = answer;
				});
				data.custom_questions = JSON.stringify(custom_questions);
			}
			fetch(
				`${process.env.VUE_APP_API_ENDPOINT}/v2/${this.keyword}/assetbooking/booking`,
				{
					method: 'POST',
					body: JSON.stringify(data),
					headers: { 'Content-Type': 'application/json' }
				}
			)
				.then(async res => {
					if (res.ok) {
						const json = await res.json();
						if (json.status === 'success') {
							this.bookingComplete = true;
							this.bookingMediated = json.data.booking_mediated;
							// Scroll to top when booking is completed
							this.$nextTick(() => {
								this.$vuetify.goTo(0);
								this.queueHeightSync();
							});
						}
					} else {
						this.submitting = false;
						this.showError = true;

						const json = await res.json();
						let errorMessageKey = 'assets.booking.error';
						if (json.message) {
							errorMessageKey = json.message;
						}
						this.errorMessage = this.$i18n.t(errorMessageKey);
					}
				})
				.catch(err => {
					this.submitting = false;
				});
		},
		finished() {
			this.$nextTick(() => {
				this.$vuetify.goTo(0);
			});
			this.$router.push({
				name: 'assets',
				params: { id: this.asset.category_id }
			});
		}
	},
	watch: {
		bookingComplete(newVal) {
			if (newVal) {
				this.$nextTick(() => {
					this.$vuetify.goTo(0);
					this.queueHeightSync();
				});
			}
		},
		asset() {
			this.queueHeightSync();
		},
		group() {
			this.queueHeightSync();
		}
	},
	computed: {
		id() {
			return parseInt(this.$route.params.id) || null;
		},
		blockSize() {
			const multiplier = parseInt(this.$route.query.multiplier) || 1;
			return this.asset.block_size * multiplier;
		},
		slot() {
			return parseInt(this.$route.params.slot) || null;
		},
		// Minutes the whole slot grid is shifted by, e.g. a 60 minute service running
		// 9:15, 10:15, 11:15. Not multiplied: it shifts the start of the day once,
		// whatever the appointment length. 0 leaves the old behaviour untouched.
		slotOffsetMinutes() {
			return (
				Number(
					this.asset.slot_offset_minutes ??
						this.group.slot_offset_minutes
				) || 0
			);
		},
		category() {
			return this.$store.getters.getAssetCategoryForId(
				this.asset.category_id
			);
		},
		group() {
			return this.$store.getters.getAssetGroupForId(this.asset.group_id);
		},
		asset() {
			return this.$store.getters.getAssetForId(this.id);
		},
		clientDetails() {
			return this.$store.state.clientDetails;
		},
		clientSettings() {
			return this.$store.state.clientSettings;
		},
		libraryTimezone() {
			return this.clientDetails.timezone;
		},
		selectedDate() {
			return this.$store.state.selectedDate;
		},
		bookingDateTime() {
			return moment(
				`${this.selectedDate} ${this.formattedSlot}`,
				'YYYY-MM-DD h:mm a'
			).format('YYYY-MM-DD HH:mm');
		},
		formattedDate() {
			return moment(this.selectedDate, 'YYYY-MM-DD').format(
				'dddd, MMMM Do YYYY'
			);
		},
		//  virtual/in-person display logic
		isVirtual: function() {
			return this.$route.query.assetType === 'ONLINE';
		},
		formattedSlot() {
			return moment()
				.utc()
				.utcOffset(this.libraryTimezone)
				.startOf('days')
				.add(
					this.slotOffsetMinutes + this.slot * this.blockSize,
					'minutes'
				)
				.format('h:mm a');
		}
	}
};
</script>

<style lang="scss">
.details {
	padding: 2em;
	background-color: #2695b5;
	max-width: 600px;
	margin: 0 auto;

	> div,
	.v-icon {
		color: #fff !important;
	}
}

div.custom-field-question {
	white-space: normal;
	overflow: visible;
	text-overflow: clip;
	overflow-wrap: break-word;
}

.mediation-information-box {
	width: 100%;
	border: 2px solid #0daabf;
	border-radius: 10px;
	padding-right: 80px;
	padding-top: 15px;
	padding-bottom: 15px;
	margin-bottom: 20px;
	margin-right: 0;

	.icon {
		display: inline-block;
		width: 25px;
		margin-left: 12px;
		margin-bottom: 0;
		content: url('data:image/svg+xml,%3Csvg%20version%3D%221.1%22%20id%3D%22Icon%3A_Error%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2035%2035%22%20style%3D%22enable-background%3Anew%200%200%2035%2035%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%20%20.st0%7Bfill%3A%230daabf%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20class%3D%22st0%22%20d%3D%22M17.5%2C1C13.1%2C1%2C8.9%2C2.7%2C5.8%2C5.8C2.7%2C8.9%2C1%2C13.1%2C1%2C17.5s1.7%2C8.6%2C4.8%2C11.7c3.1%2C3.1%2C7.3%2C4.8%2C11.7%2C4.8%0A%20%20s8.6-1.7%2C11.7-4.8c3.1-3.1%2C4.8-7.3%2C4.8-11.7s-1.7-8.6-4.8-11.7C26.1%2C2.7%2C21.9%2C1%2C17.5%2C1%20M17.5%2C0C27.2%2C0%2C35%2C7.8%2C35%2C17.5%0A%20%20S27.2%2C35%2C17.5%2C35S0%2C27.2%2C0%2C17.5S7.8%2C0%2C17.5%2C0z%22%2F%3E%0A%3Cpath%20class%3D%22st0%22%20d%3D%22M17.5%2C21.6c-0.3%2C0-0.5-0.2-0.5-0.5V8.3c0-0.3%2C0.2-0.5%2C0.5-0.5S18%2C8.1%2C18%2C8.3v12.8C18%2C21.4%2C17.8%2C21.6%2C17.5%2C21.6z%0A%20%20%22%2F%3E%0A%3Cpath%20class%3D%22st0%22%20d%3D%22M17.5%2C26.6c-0.3%2C0-0.5-0.2-0.5-0.5v-0.7c0-0.3%2C0.2-0.5%2C0.5-0.5s0.5%2C0.2%2C0.5%2C0.5v0.7%0A%20%20C18%2C26.4%2C17.8%2C26.6%2C17.5%2C26.6z%22%2F%3E%0A%3C%2Fsvg%3E');
	}

	.box-content {
		width: 290px;
		display: inline-block;
		font-size: 0.875rem;
		vertical-align: top;
		margin-left: 12px;
	}

	.box-title {
		font-weight: 600;
		font-size: 0.875rem;
		padding-bottom: 5px;
		margin: 0;
	}

	.box-message {
		margin: 0;
	}
}
</style>
